import { prayerArraySchema } from "@/schemas/prayer-data-schema";
import { IFetchPrayerResult } from "@/types/prayer-types";

export const fetchPrayer = async (): Promise<IFetchPrayerResult> => {
	try {
		const res = await fetch(
			"https://kuwait.exelys.io/kuwait_prayer_times/prayer_times.json",
		);

		if (!res.ok) {
			throw new Error("Failed to fetch");
		}

		const data = await res.json();

		const validatedData = prayerArraySchema.parse(data);

		return {
			isLoading: false,
			error: null,
			prayerData: validatedData,
		};
	} catch (err) {
		return {
			isLoading: false,
			error: "Une erreur est survenue",
			prayerData: [],
		};
	}
};
